import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function ConstMenu(props) {
  return (
    <Dropdown
      menuKey="const"
      menu={projectMenus.const}
      {...props}
    />
  );
}
